import type { JobAutoApplySettings } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const getJobAutoApplySettingsHelpers = (userId: number) =>
  clientApi.getOCClient().helpers.user.users.id(userId).jobAutoApplySettings;

const { useFind: useUserJobAutoApplySettings, useUpdate: useUpdateUserJobAutoApplySettings } =
  getCRUDHooks<JobAutoApplySettings>({
    entityName: 'userJobAutoApplySettings',
    sharedCacheEntities: ['UserPrivacySettings'],
    find: ({ userId, filters }) => getJobAutoApplySettingsHelpers(userId).find(filters),
    update: (newSettings, { userId }) =>
      getJobAutoApplySettingsHelpers(userId).update(null, newSettings),
  });

export { useUserJobAutoApplySettings, useUpdateUserJobAutoApplySettings };
